import React from 'react'
import {Navbar,Nav,Container} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'


export default function MenuAdmin({background='transparent',fixed=''}) {
	const { t } = useTranslation()     
	const {logout} = useAuth()
  	return (
		<Navbar expand="xs" fixed="top" id="menu-admin" className={`mb-5 `+ fixed}>
			<Container fluid className="justify-content-between">
				<span className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#basic-navbar-nav" aria-controls="basic-navbar-nav" aria-expanded="false" aria-label="Toggle navigation">
					<i className="fas fa-bars"></i>
				</span>
				<Link to="/admin/dashboard" className="navbar-brand">
					<img
						src="/images/logotipo.png"
						className="d-inline-block align-top justify-center"
						alt="Logotipo SD Agro"
						id="logo-menu"
					/>
				</Link>
				<div className="navbar-start"></div>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">
						<Nav.Link href="/admin/dashboard">{t('menu.inicio')}</Nav.Link>
						<Nav.Link href="/admin/users">{t('menu.user')}</Nav.Link>
						<Nav.Link href="/admin/machineries">{t('menu.machinery')}</Nav.Link>
						<Nav.Link href="/admin/counters">{t('menu.counters')}</Nav.Link>
						<Nav.Link href="/admin/products">{t('menu.products')}</Nav.Link>
						<Nav.Link href="/admin/farms">{t('menu.farms')}</Nav.Link>
						<Nav.Link href="/admin/plots">{t('menu.plots')}</Nav.Link>
						<Nav.Link href="/admin/crops">{t('menu.crops')}</Nav.Link>
						{/* <Nav.Link href="/admin/campaigns">{t('menu.campaigns')}</Nav.Link> */}
						<Nav.Link href="/admin/origens">{t('menu.origens')}</Nav.Link>
						<Nav.Link href="/admin/labors">{t('menu.labors')}</Nav.Link>
						<Nav.Link href="/admin/logs">{t('menu.logs')}</Nav.Link>
						<Nav.Link href="#" onClick={logout}>{t('menu.logout')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
}
